export default {
  background:
    'transparent linear-gradient(272deg, #821C0E 0%, #E6311E 100%) 0% 0% no-repeat padding-box;',
};
